import { useEffect, useRef } from 'react';

import { isString } from '../../../helpers/text';

type UseSearchParams = {
  labelFromValue: string;
  search?: string | null;
  onSearchChange?: (search: string | null) => void;
  placeholder?: string;
  isOpened: boolean;
};
type InputProps = {
  value: string;
  placeholder: string | undefined;
};

export const useSearch = ({
  labelFromValue,
  placeholder,
  search = null,
  onSearchChange,
  isOpened,
}: UseSearchParams): InputProps => {
  const isSearching = isString(search);

  const getInputPlaceholder = () => {
    if (isSearching) return labelFromValue || placeholder;
    else return placeholder;
  };

  const getInputValue = () => {
    if (isSearching) return search ?? '';
    else return labelFromValue ?? '';
  };

  /* Keep onSearchChange in a ref so the effect below only fires on isOpened
   * transitions. Without this, an inline onSearchChange from the parent would
   * re-trigger the effect on every render and clobber the typed value with ''. */
  const onSearchChangeRef = useRef(onSearchChange);
  onSearchChangeRef.current = onSearchChange;

  useEffect(() => {
    if (isOpened) onSearchChangeRef.current?.('');
    else onSearchChangeRef.current?.(null);
  }, [isOpened]);

  const input: InputProps = {
    value: getInputValue(),
    placeholder: getInputPlaceholder(),
  };
  return input;
};
